import { useContext, useEffect, useState } from "react"
import { IconAtom } from "../atoms/iconAtom"
import { VerticalLayout } from "./layout"
import { fetchAPI, getAPI } from "../api/api"
import { relativeTime } from "../api/date_formatting"
import { StandardButton } from "../atoms/buttons"
import { PageContext } from "../App"

export function RecentActivities() {
    const [activities, setActivities] = useState([])
    const [showAll, setShowAll] = useState(false);
    
    useEffect(() =>{
        loadActivities()
    },[])
    const loadActivities = async () => {
        const query = `api/users/@me/activities?status=recent`
        const data = await fetchAPI(query)
        const sortedActivities = data.sort((a, b) => new Date(b.start_time) - new Date(a.start_time));
        setActivities(data)
    }
    const displayedActivities = showAll ? activities : activities.slice(0, 3);
    return (
        <div className={`vertical phone-activity-comp standard-padding standard-rounded standard-border card-background-color standard-small-margin-top activities-comp ${showAll ? 'recent-activity' : ''}`} style={{ width: "unset" }}>
            <div className="horizontal space-between phone-padding small-standard-margin-bottom" style={{ alignItems: "center", width:"auto", }}>
                <p className="diagram-title">Recente activiteiten</p>
                {activities.length > 3 && (
                    <StandardButton
                        onClick={() => setShowAll(prev => !prev)}
                        title={showAll ? "Toon minder" : "Toon meer"}
                    />
                )}
            </div>
    
            {activities.length > 0 && (
                <div className="phone-activity-content" style={{ position: "relative" }}>
                    <div style={{ height: "calc(100% - 1rem)", borderRight: "1px dashed #ccc", position: "absolute", left: "1.2rem" }}></div>
                    {displayedActivities.map((activity, index) => (
                        <ActivitiesComp key={index} activity={activity} />
                    ))}
                </div>
            )}
            {activities.length === 0 && <EmptyActivitiesComp />}
        </div>
    );
}


export function LeadActivities(){
    const [activities, setActivities] = useState([])
    const [showAll, setShowAll] = useState(false);
    const page = useContext(PageContext)
    useEffect(() =>{
        loadActivities()
    },[])

    const loadActivities = async () => {
        const query = `api/leads/${page.sidebar.id_lead}/activities`
        const data = await getAPI(query)
        console.log(data.data)
        setActivities(data.data)
    }
 const displayedActivities = showAll ? activities : activities.slice(0, 3);
    return(
            <div className={`vertical phone-activity-comp standard-padding standard-rounded standard-border card-background-color standard-small-margin-top activities-comp ${showAll ? 'recent-activity' : ''}`} style={{ width: "unset" }}>
            <div className="horizontal space-between phone-padding small-standard-margin-bottom" style={{ alignItems: "center", width:"auto", }}>
                <p className="diagram-title">Recente activiteiten</p>
                {activities.length > 3 && (
                    <StandardButton
                        onClick={() => setShowAll(prev => !prev)}
                        title={showAll ? "Toon minder" : "Toon meer"}
                    />
                )}
            </div>
    
            {activities.length > 0 && (
                <div className="phone-activity-content" style={{ position: "relative" }}>
                    <div style={{ height: "calc(100% - 1rem)", borderRight: "1px dashed #ccc", position: "absolute", left: "1.2rem" }}></div>
                    {displayedActivities.map((activity, index) => (
                        <ActivitiesComp key={index} activity={activity} />
                    ))}
                </div>
            )}
            {/* {activities.length === 0 && <EmptyActivitiesComp />} */}
        </div>
    )
}
export function ActivitiesComp({ activity }) {
    return (
        <div className="horizontal complete-width standard-small-margin-bottom" style={{ alignItems: "unset" }}>
            <div className="standard-border standard-rounded medium-icon">
                <IconAtom icon2={ActivityIconFactory(activity.type_activity)} />
            </div>
            <VerticalLayout>
                <div className="horizontal">    
                    <p className="small-text-light">{ActivityName(activity.type_activity)}</p>
                    <p className="small-text-light">&nbsp;{``}</p>
                </div>
                <div className="horizontal complete-width space-between">
                    <p className="small-text-dark">{activity.activity_name}</p>
                    <p className="small-text-light">{relativeTime(new Date(activity.start_time), true)}</p>
                </div>
            </VerticalLayout>
        </div>
    );
}

export function EmptyActivitiesComp() {
    return (
        <div className="horizontal complete-width standard-small-margin-bottom" style={{ alignItems: "center" }}>
             <div className="standard-border standard-rounded medium-icon">
                <IconAtom icon2="book-off" style={{ color: "var(--grey-500)" }} />
            </div>
            <VerticalLayout>
                <p className="small-text grey-600">Geen recente activiteiten</p>
                <p className="small-text grey-500">Begin met een cursus om je activiteiten hier te zien.</p>
            </VerticalLayout>
        </div>
    );
}
function ActivityIconFactory(activityType) {
    switch (activityType) {
        case "course":
            return "book"
        case "lesson":
            return "school"
        case "linkedin":
            return "social"
        case "linkedin":
            return "social"
    }
}

function ActivityName(activityType) {
    switch (activityType) {
        case "course":
            return "Cursus"
        case "lesson":
            return "Les"
        case "linkedin":
            return "Linkedin interacties"
    }
}